import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../core/gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../core/gd-components/gd-popover/popover-position"
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import SelectGenericPopoverSearch from "./popover-search"
import SelectGenericPopoverOptionsSelector from "./popover-options-selector"
import SelectGenericNew from "../select-generic-new";

const SEARCH_SHOW_THRESHOLD = 6; // min options to show search input

const debug = false
// const debug = "SelectGenericPopoverMenu"

type Props = {
    parent                          : SelectGenericNew

    options                         : Options

    noValueOptionLabel?             : string
    noValueOption?                  : boolean   // is all values option available

    popoverContainerClasses?        : string
    popoverClasses?                 : string
    popoverScrollContainerClasses?  : string

    isSearchable?                   : boolean

    popoverOptionComponent?         : callback
}

type State = {
    searchString: string
}

export default class SelectGenericPopoverMenu extends React.Component<Props, State> {

    public optionsSelector! : any
    public scroll!          : any

    constructor(props: Props) {
        super(props);

        this.state = {
            searchString: ""
        }
    }

    onPopoverKeyDown = (e: KeyboardEvent) => {if(this.optionsSelector) this.optionsSelector.onPopoverKeyDown(e)}

    onSearchChange = (newSearchString: string) => {
        this.setState({
            searchString: newSearchString
        })
    }

    updateScroll = (node: any, isCentered = false) => {
        debug && console.log(debug, "updateScroll", node, isCentered, this.scroll)

        if (!node || !this.scroll) return

        const scrollNode: any = findDOMNode(this.scroll.childrenContainer)

        const nodeTop       = node.offsetTop
        const nodeBottom    = node.offsetTop + node.offsetHeight
        const scrollTop     = scrollNode.scrollTop
        const scrollBottom  = scrollNode.scrollTop + scrollNode.offsetHeight

        debug && console.log(debug, "updateScroll", scrollBottom < nodeBottom, scrollTop > nodeTop)

        // ensure node to be in visible area of scroll
        if (isCentered)                     this.scroll.setScrollTop((nodeTop + nodeBottom) / 2, true, 0)
        else if (scrollBottom < nodeBottom) this.scroll.setScrollTop(nodeBottom - scrollNode.offsetHeight, false, 100)
        else if (scrollTop > nodeTop)       this.scroll.setScrollTop(nodeTop, false, 100)
    }

    render() {
        const popoverPosition = new PopoverPosition({
            attachment      : "top center",
            targetAttachment: "bottom center",
        })

        return (
            <Popover className        = {Classes("generic-popover-menu", this.props.popoverContainerClasses)}
                     position           = {popoverPosition}
                     getTargetFunc      = {()=>findDOMNode(this.props.parent)}
                     onKeyDown          = {this.onPopoverKeyDown}
                     onClickOutside     = {()=>{this.props.parent.hidePopover()}}>

                <SelectGenericPopoverSearch searchable        = {this.props.isSearchable && this.props.options.length > SEARCH_SHOW_THRESHOLD}
                                            searchString      = {this.state.searchString}
                                            onHidePopover     = {this.props.parent.hidePopover}
                                            onSearchChange    = {this.onSearchChange}/>

                <div className={Classes("ui5-popover-menu", this.props.popoverClasses)}>
                    <VScroll ref={(r: any)=>this.scroll = r} minDragHeight={20} containerClass={this.props.popoverScrollContainerClasses} scrollVisibility="auto">
                        <SelectGenericPopoverOptionsSelector ref                    = {(r: any)=>this.optionsSelector = r}
                                                             parent                 = {this.props.parent}
                                                             options                = {this.props.options}
                                                             noValueOptionLabel     = {this.props.noValueOptionLabel}
                                                             noValueOption          = {this.props.noValueOption}
                                                             popoverOptionComponent = {this.props.popoverOptionComponent}
                                                             searchString           = {this.state.searchString}
                                                             onUpdateScroll         = {this.updateScroll}/>
                    </VScroll>
                </div>
            </Popover>
        )
    }
}
